<template>
  <div>
     <el-card>
      <search-form ref="searchForm" :topVisible="true" :tabData="tabData" labelWidth="120px" :searchFormData="searchFormData" @search="search" @tabChange="tabChange">
        <template #topBtn>
          <el-button type="primary" size="small" @click="handleExport">{{$t('button.batchExport')}}</el-button>
          <el-button class="marginRight20" type="primary" size="small" @click="handleClick('create')">{{ $t('text.add') }}</el-button>
        </template>
      </search-form>
      <create-table :operationColWidth="150" @handleNewTab="handleNewTab($event, 'addressDetail')" :autoWidth="true" :operateVisible="operateVisible" ref="createTable" :loading="loading" :btnType="[]" :total_count="pageData.total_count ? pageData.total_count : 0" :current_page.sync="pageData.page" :papeSize.sync="pageData.per_page" @selectionChange="selectionChange" :topButtonVisible="true" :tableData="tableData" :tableDataItem="tableDataItem" @operate="handleClick" :pageVisible="true" :pageData="pageData" :checkBoxVisible="dropDataItem.length > 0" @handleSort="handleSort">
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></allButton>
        </template>
        <template #rightBtn="scope">
          <el-button :class="item.action === 'view' ? 'operate_view' : ''" class="margintop10" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view/>
    <dialogEffect v-if="dialogVisible" :opereteDate="false" :todayVisible="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import { getMemberAddressSetup, getMemberAddressList, getMemberAddressExport, deleteMemberAddressSingle } from '@/services/members'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'managerUserOrders',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem
    }
  },
  watch: {
    $route (to, from) {
      // console.log(from)
      // if (from.name === 'managerUserOrderView') {
      //   this.$nextTick(() => {
      //     this.search()
      //     this.$refs.createTable.$refs.table.doLayout()
      //   })
      // }
    }
  },
  created () {
    this.queryData(getMemberAddressSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getMemberAddressSetup)
    this.isActive = true
  },
  methods: {
    // 导出数据接口
    handleExport () {
      const params = this.$route.params.id ? { user_id_eq: this.$route.params.id } : null
      this.$refs.searchForm.commonOperate(getMemberAddressExport, (data) => {
        this.$router.push({
          name: 'memberAddressDownloadCenter',
          params: { data }
        })
      }, this, params)
    },
    // 点击操作按钮
    async handleClick (type, data) {
      if (type?.action === 'view') {
        this.$router.push({
          name: 'addressDetail',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'edit') {
        this.$router.push({
          name: 'addressEdit',
          params: {
            id: data.id.value
          }
        })
      }
      if (type === 'create') {
        if (this.$route.params.id) {
          this.$router.push({
            name: 'memberAddressAdd',
            params: {
              id: this.$route.params.id
            }
          })
        } else {
          this.$router.push({
            name: 'addressAdd'
          })
        }
      }
      if (type?.action === 'destroy') {
        this.deleteClick(data, deleteMemberAddressSingle)
      }
    },
    // 查询
    search (data) {
      if (data) this.searchData = data
      if (this.$route.params.id) {
        this.searchData.user_id_eq = this.$route.params.id
      }
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getMemberAddressList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>

</style>
